import { InjectionToken } from '@angular/core';

export const DataRemovalToken = new InjectionToken<IDataRemoval>('DataRemovalToken');

export interface IDataRemoval {
  clean(): Promise<void>;
}
